<template>
  <div class="about-page">
    <navTab></navTab>
    <div class="page_1">
      <img v-if="$isPC" src="https://global-cdn.imscv.com/tewamoto/v3/ABOUT-1.jpg" alt="">
      <img v-else src="https://global-cdn.imscv.com/tewamoto/mobile-v3/ABOUT-1.png" alt="">
      <div class="txt-box">
        <div class="txt1" v-if="$isPC">@ TEWA MOTO <br /> IN IT TO WIN IT</div>
        <div class="txt1" v-else>@ TEWA MOTO &nbsp;&nbsp;&nbsp; IN IT TO WIN IT</div>
        <div class="txt2">We aim to become a leader in high-performance, clean-energy power sports. Our vision is to create the most advanced, most fun, and most inspiring clean-energy power products for all riders.
        </div>
      </div>
    </div>
    <div class="page_2">
      <div class="text_content">
        <div class="t1">Mission</div>
        <div class="t2">At our mission is to redefine the world of power sports through clean energy and cutting-edge
          technology. We believe that performance and sustainability can coexist — and that the future of adventure
          should be both thrilling and responsible.</div>
      </div>
      <img v-if="$isPC" src="https://global-cdn.imscv.com/tewamoto/v3/ABOUT-2.jpg" alt="">
      <img v-else src="https://global-cdn.imscv.com/tewamoto/mobile-v3/ABOUT-2.jpg" alt="" />
    </div>
    <div class="page_3">
      <div class="text_content">
        <div class="t1">Commitment</div>
        <div class="t2">As a U.S.-based brand, TEWA MOTO brings together the best global talents in design, engineering, and manufacturing.
        </div>
        <div class="t3">We are not just building vehicles — we are building a new way of moving, playing, and living
          with energy.
        </div>
        <div class="t2">To deliver clean, powerful, and fun mobility experiences for the next generation of riders.
        </div>
      </div>
      <img v-if="$isPC" src="https://global-cdn.imscv.com/tewamoto/v3/ABOUT-3.jpg" />
      <img v-else src="https://global-cdn.imscv.com/tewamoto/mobile-v3/ABOUT-3.png" alt="" />
    </div>
    <div class="page_4"></div>
    <FooterTemp></FooterTemp>
  </div>
</template>

<script>
  import navTab from '../components/navTab.vue'
  import FooterTemp from '../components/footer.vue'
  export default {
    name: 'AboutPage',
    components: { navTab, FooterTemp },
    data () {
      return {

      }
    },
    mounted () {
      window.scrollTo(0, 0)

    },
    methods: {

    }
  }
</script>

<style scoped lang="scss">
  img {
    display: block;
  }

  @import url('https://fonts.googleapis.com/css2?family=Tilt+Warp&display=swap');
  @media (min-width: 769px) {


    .about-page {
      box-sizing: border-box;
      background: #000;

      .page_1 {
        position: relative;
        width: 100%;
        height: 100vh;

        img {
          width: 100%;
          height: 100%;
          object-fit: cover;    // 100vh 全屏 hero：按比例裁切铺满，不拉伸变形
          object-position: center;
        }

        .txt-box {
          position: absolute;
          right: 0;
          bottom: 0;
          padding: 50px 90px;
          box-sizing: border-box;
          display: flex;
          flex-direction: column;
          justify-content: space-between;
          align-items: flex-start;
          row-gap: 30px;
          color: #f5f5f5;
          font-family: "AlibabaPuHuiTi";

          .txt1 {
            font-size: 27.77px;
            font-weight: 800;
          }

          .txt2 {
            font-size: 18.05px;
          }
        }
      }

      .page_2 {
        width: 100%;
        /* PC 宽屏：内容压在 1440px 内居中 */
        padding: 100px max(97px, calc((100% - 1440px) / 2));
        box-sizing: border-box;

        .text_content {
          width: 100%;
          display: flex;
          justify-content: space-between;
          align-items: flex-start;
          font-family: "AlibabaPuHuiTi";
          gap: 100px;

          .t1 {
            font-size: 48px;
            font-weight: 900;
            color: #FFA400;
          }

          .t2 {
            font-size: 18.05px;
            color: rgba(255, 255, 255, .8);
            font-weight: 500;
          }
        }

        img {
          width: 100%;
          height: 100%;
          object-fit: contain;  // 防止固定高度下拉伸变形
          margin-top: 40px;
        }
      }

      .page_3 {
        width: 100%;

        .text_content {
          width: 100%;
          font-family: "AlibabaPuHuiTi";
          text-align: center;
          /* PC 宽屏：文字块左右内缩对齐 1440px 内容容器 */
          padding: 0 max(60px, calc((100% - 1440px) / 2));
          box-sizing: border-box;

          .t1 {
            font-size: 48px;
            font-weight: 900;
            color: #FFA400;
          }

          .t2 {
            font-size: 18.05px;
            font-weight: 400;
            color: rgba(255, 255, 255, .8);
          }

          .t3 {
            font-size: 22.22px;
            font-weight: 900;
            color: #FFA400;
          }
        }

        img {
          width: 100%;
          height: auto;
          margin-top: 70px;
        }
      }

      .page_4 {
        width: 100%;
        height: 100px;
        background-color: #191919;
      }
    }
  }

  @media (max-width: 768px) {
    .about-page {
      box-sizing: border-box;
      background: #000;

      .page_1 {
        width: 100%;
        position: relative;

        img {
          width: 100%;
          height: 100%;
        }

        .txt-box {
          position: absolute;
          left: 0;
          bottom: 0;
          padding: 20px 20px;
          box-sizing: border-box;
          display: flex;
          flex-direction: column;
          justify-content: space-between;
          align-items: flex-start;
          row-gap: 20px;
          color: #000;
          font-family: "AlibabaPuHuiTi";

          .txt1 {
            font-size: 14px;
            font-weight: 900;
          }

          .txt2 {
            font-size: 10px;
            font-size: 700;
          }
        }
      }

      .page_2 {
        width: 100%;
        margin-top: 40px;

        img {
          width: 100%;
          height: auto;
          margin-top: 20px;
        }

        .text_content {
          padding-left: 20px;
          box-sizing: border-box;
          font-family: "AlibabaPuHuiTi";

          .t1 {
            font-size: 22.22px;
            color: #FFA400;
            font-weight: 900;
          }

          .t2 {
            font-size: 10px;
            font-weight: 500;
            color: rgba(255, 255, 255, .8);
          }
        }
      }

      .page_3 {
        width: 100%;
        margin-top: 40px;
        box-sizing: border-box;

        img {
          width: 100%;
          height: auto;
          margin-top: 20px;
        }

        .text_content {
          padding: 0 20px;
          box-sizing: border-box;
          font-family: "AlibabaPuHuiTi";

          .t1 {
            font-size: 22.22px;
            font-weight: 900;
            color: #FFA400;
          }

          .t2 {
            font-size: 10px;
            color: rgba(255, 255, 255, .8);
          }

          .t3 {
            font-size: 14px;
            font-weight: 900;
            color: #FFA400;
          }
        }
      }

      .page_4 {
        width: 100%;
        height: 40px;
        background-color: #191919;
      }
    }
  }
</style>